import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useWorkspace } from "../../contexts/Workspacecontext";
import {
  filterMenuByRoles,
  getNavigationByWorkspace,
  isMenuItemActive,
} from "../../config/navigation";
import SidebarItem from "./SidebarItem";
import "./Sidebar.scss";

const Sidebar = ({ notificationCounts = {} }) => {
  const { user } = useAuth();
  const { workspace } = useWorkspace();
  const [hoveredItem, setHoveredItem] = useState(null);
  const location = useLocation();

  if (!user || !workspace) return null;

  const userRoles = user.authorities || [];
  const filteredMenuItems = filterMenuByRoles(
    getNavigationByWorkspace(workspace),
    userRoles,
  );

  return (
    <div className="sidebar-wrap">
      <ul className="sidebar app-sidebar">
        {filteredMenuItems.map((item) => (
          <SidebarItem
            key={item.name}
            item={item}
            isHovered={hoveredItem === item.name}
            isActive={isMenuItemActive(item, location.pathname)}
            onHover={setHoveredItem}
            onClick={() => setHoveredItem(item.name)}
            userRoles={userRoles}
            notificationCount={notificationCounts[item.name] || 0}
          />
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
